// src/pages/Innovation.js 
// (Assuming this file contains your Innovation component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import InnovationContent from './PageComponent/InnovationContent';


function Innovation() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Innovation | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Discover the latest in innovation at Marvel Lifestyle. Explore ideas that transform everyday living. Join us and inspire your journey today!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/innovation/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Innovation" />
                <meta
                    property="og:description"
                    content="Discover the latest in innovation at Marvel Lifestyle. Explore ideas that transform everyday living. Join us and inspire your journey today!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/innovation/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <InnovationContent />
                <Footer />
            </div>
        </>
    );
}

export default Innovation;